import {createEffect} from "effector";
import {logger} from "./logger";
import {getValuesForInitLogger} from "./utils";
import {AxiosResponse} from "axios";
import {GetConfigResponse} from "api/configs";
import {LogErrorOptions, LogEventParams} from "./types";

export const initLoggerFx = createEffect((data?: AxiosResponse<GetConfigResponse, any>) => {
    logger.initLogger(getValuesForInitLogger(data));
});

export const logEventStringFx = createEffect((name: string) => {
    logger.logEventString(name)
});

export const logErrorFx = createEffect(({params, error}: {params: LogErrorOptions, error: Error}) => {
    logger.error(params, error)
});